import type { ReactNode } from "react"
import {
  CopyOutlined,
  CreditCardOutlined,
  ExperimentOutlined,
  GiftOutlined,
  HistoryOutlined,
  PictureOutlined,
  RollbackOutlined,
  ScissorOutlined,
  ShopOutlined,
  ThunderboltOutlined,
  UnorderedListOutlined,
  UserOutlined,
  VideoCameraOutlined,
} from "@ant-design/icons"
import { ROUTER } from "~/common/router"
import { Staff } from "~/pages/Staff"
import { StaffDoudianGift } from "~/pages/Staff/DoudianGift"
import { StaffDoudianOrderList } from "~/pages/Staff/DoudianOrderList"
import { StaffEnhanceVideoTaskList } from "~/pages/Staff/EnhanceVideoTaskList"
import { StaffEraseVideoSubtitleTaskList } from "~/pages/Staff/EraseVideoSubtitleTaskList"
import { StaffFrameCopyTaskList } from "~/pages/Staff/FrameCopyTaskList"
import { StaffGift } from "~/pages/Staff/Gift"
import { StaffLab } from "~/pages/Staff/Lab"
import { StaffOrderCleanup } from "~/pages/Staff/OrderCleanup"
import { StaffOrderCleanupHistory } from "~/pages/Staff/OrderCleanupHistory"
import { StaffOrderRefund } from "~/pages/Staff/OrderRefund"
import { StaffOrderList } from "~/pages/Staff/OrderList"
import { StaffUserList } from "~/pages/Staff/UserList"
import { StaffUserVideoList } from "~/pages/Staff/UserVideoList"
import { StaffVideoCover } from "~/pages/Staff/VideoCover"
import { StaffVideoTemplates } from "~/pages/Staff/VideoTemplates"
import { StaffRecreate } from "./Recreate"

type StaffPage = {
  path: string
  element: ReactNode
  // 有 menu 的页面出现在侧边菜单，顺序即菜单顺序；没有的只能通过路由访问
  menu?: { icon: ReactNode; label: string }
}

// Staff 路由与菜单的唯一来源
export const STAFF_PAGES: StaffPage[] = [
  {
    path: ROUTER.STAFF_ORDER_LIST,
    element: <StaffOrderList />,
    menu: { icon: <UnorderedListOutlined />, label: "订单列表" },
  },
  {
    path: ROUTER.STAFF_GIFT,
    element: <StaffGift />,
    menu: { icon: <GiftOutlined />, label: "权益赠送" },
  },
  {
    path: ROUTER.STAFF_DOUDIAN_GIFT,
    element: <StaffDoudianGift />,
    menu: { icon: <ShopOutlined />, label: "抖店权益赠送" },
  },
  {
    path: ROUTER.STAFF_DOUDIAN_ORDER_LIST,
    element: <StaffDoudianOrderList />,
    menu: { icon: <UnorderedListOutlined />, label: "抖店订单列表" },
  },
  {
    path: ROUTER.STAFF_VIDEO_COVER,
    element: <StaffVideoCover />,
    menu: { icon: <PictureOutlined />, label: "视频生成封面" },
  },
  {
    path: ROUTER.STAFF_VIDEO_TEMPLATES,
    element: <StaffVideoTemplates />,
    menu: { icon: <VideoCameraOutlined />, label: "视频模板" },
  },
  {
    path: ROUTER.STAFF_USER_LIST,
    element: <StaffUserList />,
    menu: { icon: <UserOutlined />, label: "用户列表" },
  },
  {
    path: ROUTER.STAFF_USER_VIDEO_LIST,
    element: <StaffUserVideoList />,
    menu: { icon: <VideoCameraOutlined />, label: "用户制作视频列表" },
  },
  {
    path: ROUTER.STAFF_FRAME_COPY_TASK_LIST,
    element: <StaffFrameCopyTaskList />,
    menu: { icon: <CopyOutlined />, label: "视频复刻任务" },
  },
  {
    path: ROUTER.STAFF_ERASE_VIDEO_SUBTITLE_TASK_LIST,
    element: <StaffEraseVideoSubtitleTaskList />,
    menu: { icon: <ScissorOutlined />, label: "去字幕任务" },
  },
  {
    path: ROUTER.STAFF_ENHANCE_VIDEO_TASK_LIST,
    element: <StaffEnhanceVideoTaskList />,
    menu: { icon: <ThunderboltOutlined />, label: "画质提升任务" },
  },
  {
    path: ROUTER.STAFF_LAB,
    element: <StaffLab />,
    menu: { icon: <ExperimentOutlined />, label: "实验室" },
  },
  {
    path: ROUTER.STAFF_ORDER_REFUND,
    element: <StaffOrderRefund />,
    menu: { icon: <RollbackOutlined />, label: "订单退款" },
  },
  {
    path: ROUTER.STAFF_ORDER,
    element: <Staff />,
    menu: { icon: <CreditCardOutlined />, label: "人工录入订单" },
  },
  {
    path: ROUTER.STAFF_ORDER_CLEANUP_HISTORY,
    element: <StaffOrderCleanupHistory />,
    menu: { icon: <HistoryOutlined />, label: "危险操作记录" },
  },
  {
    path: ROUTER.STAFF_RECREATE,
    element: <StaffRecreate />,
    menu: { icon: <VideoCameraOutlined />, label: "融合脚本生成视频" },
  },
  // 危险操作页面，不放入菜单
  {
    path: ROUTER.STAFF_ORDER_CLEANUP,
    element: <StaffOrderCleanup />,
  },
]
